import { updateState } from "../helpers/functions"

const loginReducer = (state, action) => {
    switch (action.type) {
        case "username": return updateState(state, "username", action.payload)
        case "password": return updateState(state, "password",  action.payload)
        default: return state
    }
}
export default loginReducer